module.exports = __webpack_public_path__ + "static/media/github_finder.5946bf23.png";